/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type deleteBotOfferConfigurationMutationVariables = {
  id: string;
};
export type deleteBotOfferConfigurationMutationResponse = {
  readonly poshmarkDeleteBotOfferConfiguration: {
    readonly success: boolean;
  } | null;
};
export type deleteBotOfferConfigurationMutation = {
  readonly response: deleteBotOfferConfigurationMutationResponse;
  readonly variables: deleteBotOfferConfigurationMutationVariables;
};

/*
mutation deleteBotOfferConfigurationMutation(
  $id: String!
) {
  poshmarkDeleteBotOfferConfiguration(id: $id) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'PoshmarkDeleteBotOfferConfigurationResponse',
        kind: 'LinkedField',
        name: 'poshmarkDeleteBotOfferConfiguration',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'deleteBotOfferConfigurationMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'deleteBotOfferConfigurationMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '69ca67b4ba61fd7001627405417a129c',
      id: null,
      metadata: {},
      name: 'deleteBotOfferConfigurationMutation',
      operationKind: 'mutation',
      text: 'mutation deleteBotOfferConfigurationMutation(\n  $id: String!\n) {\n  poshmarkDeleteBotOfferConfiguration(id: $id) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = '7f6178a07969f2ec41c0d4858cae6682';
export default node;
